import { useState } from "react";
import { useLicenseDetails } from "../../contexts/licenseDetails";
import LicenseService from "../../services/LicensesService";
import Button from "../Button/Button";

export function LicenseDeletePage({ license }) {
   const { closeModal, setCurrentSubTab } = useLicenseDetails();
   const [isSubmitting, setIsSubmitting] = useState(false);

   async function handleDelete() {
      setIsSubmitting(true);
      try {
         const response = await LicenseService.deleteLicense(license.id);
         if (response?.status >= 200 && response.status < 300) {
            closeModal();
         }
      } finally {
         setIsSubmitting(false);
      }
   }

   return (
      <div className="fade-in mt-0.5!">
         <h2 className="font-bold! text-[15px]!">Deletar licença</h2>
         <p className="mt-3! opacity-60 leading-snug!">
            Esta ação remove permanentemente a licença {license?.tag}. Esta operação não pode ser desfeita.
         </p>
         <div className="w-full flex flex-row items-center justify-end gap-3! mt-7!">
            <Button
               className="button-white"
               label="Cancelar"
               onClick={() => setCurrentSubTab(null)}
               disabled={isSubmitting}
            />
            <Button
               className="button-red"
               label="Deletar licença"
               onClick={handleDelete}
               isLoading={isSubmitting}
               disabled={isSubmitting}
            />
         </div>
      </div>
   );
}
